<template>
  <main>
    <h1>404 Not Found</h1>
  </main>
</template>
